<template>
    <v-container>
        <!-- pagination -->
        <v-row no-gutters class="roma-pagination mb-3 d-none d-md-block">
            <div class="d-flex wrapper align-center justify-end">
                <RomaPagination :pages="dpTotalPages ? dpTotalPages : 1" />
            </div>
        </v-row>
        <!-- class list -->
        <v-row v-if="this.items.content">
            <v-col
                cols="12"
                xs="12"
                sm="6"
                :md="
                    (drawer && gridLesson) || (!drawer && gridLesson)
                        ? getCols
                        : '12'
                "
                lg="3"
                xl="3"
                v-show="gridLesson"
                v-for="(lesson, index) in items.content"
                :key="index"
            >
                <LessonCard :lesson="lesson" />
            </v-col>
            <v-col
                v-show="!gridLesson"
                cols="12"
                v-for="(lesson, i) in items.content"
                :key="'A' + i"
            >
                <LessonCard :lesson="lesson" />
            </v-col>
        </v-row>
        <!-- paginatio -->
        <!-- <v-row no-gutters class="roma-pagination mt-4 d-none d-md-block">
            <RomaPagination :pages="dpTotalPages" />
        </v-row> -->
    </v-container>
</template>

<script>
import LessonCard from "@/components/lesson/RomaLessonCard.vue";
import RomaPagination from "@/components/commons/RomaPagination";
import { mapGetters, mapActions } from "vuex";
export default {
    props: ["items"],
    data() {
        return {
            totalPages: 0
        };
    },
    components: {
        LessonCard,
        RomaPagination
    },
    computed: {
        ...mapGetters({
            drawer: "getDrawer"
        }),
        gridLesson() {
            return this.$store.getters.getGridColumnLesson;
        },
        getCols() {
            let cols = "3";
            if (this.drawer === false) {
                cols = "4";
            }
            return cols;
        },
        dpTotalPages() {
            return this.items.totalPages;
        }
    },
    mounted() {
        this.totalPages = this.items.totalPages;
    },
    methods: {
        ...mapActions({
            actionGetLessons: "actionGetLessons"
        })
    }
};
</script>

<style lang="scss">
.roma-pagination {
    .wrapper {
        display: flex;
        .select-pagination {
            max-width: 100px;
            .v-text-field__details {
                display: none;
            }
        }
    }
}
</style>
